import React from 'react';
import { SkeletonBox } from '../../components/Skeleton/SkeletonBox';
import styles from './Document.CardSkeleton.module.css';

function DocumentCardSkeleton() {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonTextGroup}>
        <SkeletonBox width="40%" height="14px" />
        <SkeletonBox width="30%" height="10px" />
      </div>
      <SkeletonBox width="20%" height="10px" />
    </div>
  );
}

export default DocumentCardSkeleton;
